const CropScheduleVariant = {

    "crop": "Crop",
    "variant_name": "Variant Name",
    "description": "Description",
    "status": "Status",
    "search": "Search",

    "cropScheduleVariant": "Crop Schedule Variant",

    "error_crop": "Select Crop",
    "error_variant_name": "Enter Variant Name",
    "error_description": "Enter Description",
    "error_status": "Select Status",

    "table_crop": "CROP",
    "table_variant_name": "VARIANT NAME",
    "table_description": "DESCRIPTION",
    "table_status": "STATUS",

}

export default CropScheduleVariant;
